<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <span><CIcon name="cil-grid" class="mr-2"/> {{caption}} </span>
        <!---<CButton color="primary" class="px-4" @click="add()">Add Questions</CButton>-->
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
		tableFilter
		sorter		
		itemsPerPageSelect 		
      >
      <1---<template #status="{item}">         
		  <td>
			    <CBadge :color="getBadge(item.status)" v-on:click="change_status(item.Role_Id);" :id="'status_'+item.Role_Id">{{item.status}}</CBadge>
      </td>
    </template>
    <template #action="{item}">         
		  <td>            
			<CButton :color="getDelete(item.action)" @click="deletepop(item.feedback_form_id)">Delete</CButton>
          </td>
      </template>--->
	  
      </CDataTable>
	 
	 
    </CCardBody>
  </CCard>
</template>


<script>
import axios from "axios";
export default {
  name: 'Manage_assign_answer_modules',
  data () {
    return {
      myModal: false
	}
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {        
		return ['feedback_form_id','module_name', 'purpose','question','answer']
      }
    },
    caption: {
      type: String,
      default: 'Assigned Modules'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    responsive: Boolean
  },
  methods: {
	getEdit (color) {
      return 'primary';
    },
	getDelete(color){
		return 'danger';
	},
	edit(feedback_form_id){		
		localStorage.setItem("feedback_form_id",feedback_form_id);		
		this.$router.push({path:'edit_questions'})
	},
	deletepop(id){
		this.$swal.fire({
		  title: 'Are you sure?',
		  text: "You won't delete this!",
		  icon: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Yes, delete it!'
		}).then((result) => {
		  if (result.isConfirmed) {
			var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
			var token=localStorage.getItem("auth");	
			var requestInfo = {				
				Token:token,
				Session_User_Id:Session_User_Id,
			};
			console.log(requestInfo);
			//return false;
			var data = JSON.stringify(requestInfo);				
			var self = this;
			var config = {
			  method: 'delete',
			  url: feedbackApiURL+'deleteFeedbackQuestion/'+id,
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
			};
			axios(config)
			.then(function (result) {
				console.log(result);
				if(result.data.status_code==200){					
					self.$swal.fire({
						title: "Deleted", 
						text: "Your record has been deleted.", 
						type: "success"					  
					}).then(function(){ 
					   location.reload();
					   }
					);					
				}else{
					self.$swal.fire({
					  icon: 'error',
					  title: 'Oops...',
					  text: result.data.message		 
					})					
				}
			  
			})
			.catch(function (error) {
				//var errorObject=JSON.stringify(error.response.data.errors);			
				//console.log(errorObject);
				self.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: 'Something went wrong!'		 
				})
			});			
		  }
		})		
	},
	add(){
		// console.log('add');
		this.$router.push({path:'Add_questions'})
	},
  },
}
</script>